import { supabase } from './supabase';

const COOKIE_NAME = 'nnhc_session';
const LOGIN_URL = 'https://app.nurturingnurses.net/login';

function readCookie(name) {
  if (typeof document === 'undefined') return null;
  const parts = document.cookie ? document.cookie.split(';') : [];
  for (const part of parts) {
    const [k, ...rest] = part.trim().split('=');
    if (k === name) {
      try {
        return decodeURIComponent(rest.join('='));
      } catch {
        return rest.join('=');
      }
    }
  }
  return null;
}

function clearCookie(name) {
  const domains = ['', '.nurturingnurses.net', 'nurturingnurses.net'];
  for (const d of domains) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d ? `; domain=${d}` : ''}`;
  }
}

export function redirectToLogin() {
  const returnTo = encodeURIComponent(window.location.href);
  window.location.replace(`${LOGIN_URL}?return_to=${returnTo}`);
}

export async function logout() {
  try {
    await supabase.auth.signOut();
  } catch {
    /* ignore */
  }
  clearCookie(COOKIE_NAME);
  redirectToLogin();
}

export async function bootstrapSession() {
  const raw = readCookie(COOKIE_NAME);
  if (!raw) {
    return { ok: false, reason: 'no_cookie' };
  }

  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return { ok: false, reason: 'malformed_cookie' };
  }

  const access_token = parsed.access_token;
  const refresh_token = parsed.refresh_token;

  if (!access_token || !refresh_token) {
    return { ok: false, reason: 'missing_tokens' };
  }

  const { data, error } = await supabase.auth.setSession({
    access_token,
    refresh_token,
  });

  if (error || !data?.user) {
    return { ok: false, reason: 'session_invalid', error };
  }

  return { ok: true, user: data.user, session: data.session };
}
